import * as Popover from '@radix-ui/react-popover'

import { MdClose as CloseIcon } from 'react-icons/md'
import { NotifiedPerson } from '@/types/demandReports'
import { useReportOptions } from '@/hooks/reports/useReportOptions'

export function Options({ notifiedPerson }: { notifiedPerson: NotifiedPerson }) {
  const { toggleReportOptionsValue } = useReportOptions()

  return (
    <Popover.Root>
      <Popover.Trigger
        aria-label="Menu"
        className="ml-7 flex size-6 items-center justify-center rounded-full transition-colors hover:bg-cromai-m3-sys-light-surface-variant dark:hover:bg-cromai-m3-sys-dark-surface-variant"
      >
        <CloseIcon
          size={16}
          className="text-cromai-m3-sys-light-on-surface dark:text-cromai-m3-sys-dark-on-surface"
          onClick={() =>
            toggleReportOptionsValue('notifiedPeople', {
              userId: notifiedPerson.userId,
              userName: notifiedPerson.userName,
              email: notifiedPerson.email
            }, 'userId')
          }
        />
      </Popover.Trigger>
      <Popover.Content
        align="end"
        alignOffset={-16}
        className="flex flex-col rounded bg-cromai-m3-sys-light-surface2 py-1.5 shadow-lightElevation2 dark:bg-cromai-m3-sys-dark-surface2 dark:shadow-darkElevation2"
      >
      </Popover.Content>
    </Popover.Root>
  )
}
